// filepath: src/services/stripe.ts
import { backendAPI } from './base_api';

/**
 * Creates or retrieves a Stripe Customer for the given user.
 * Returns the Stripe Customer ID.
 */
export async function createCustomerSession(email: string, userId: string): Promise<string> {
  const res = await backendAPI('post', '/api/stripe/customer-session', { email, user_id: userId });
  // Assumes backend returns { customerId: string } or { clientSecret: string }
  return res.data.customerId as string;
}
/**
 * Get pricing table for Stripe products
 */
export async function getBusinessPlans(productType: string = 'app'): Promise<any[]> {
  const res = await backendAPI('get', '/api/stripe/business-plans', { product_type: productType });
  return res.data;
}

/**
 * Create a Stripe Checkout Session for the given price and customer.
 * Returns the session ID.
 */
export async function createCheckoutSession(
  priceId: string,
  customerId: string,
  successUrl: string,
  cancelUrl: string,
  couponCode?: string,
): Promise<string> {
  const payload: Record<string, string> = {
    price_id: priceId,
    customer_id: customerId,
    success_url: successUrl,
    cancel_url: cancelUrl,
  };
  if (couponCode) payload.coupon_code = couponCode;

  const res = await backendAPI('post', '/api/stripe/create-checkout-session', payload);
  return res.data.sessionId as string;
}

export const getFreePlan = (): Promise<any> => {
  return backendAPI('GET', '/api/stripe/free-plan', {});
};
